exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.font-size-17{\n\tfont-size: 17px;\n}\n\ntextarea.min-height-110{\n\tmin-height: 110px;\n}\n\ninput.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\ntextarea.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\nselect.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n.master_error_message\n{\n\tcolor: red;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/masters/consignor/consignor.component.css
// module id = ../../../../../src/app/masters/consignor/consignor.component.css
// module chunks = main